import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    profile: {},
};

export default createSlice({
    name: 'user',
    initialState,
    reducers: {
        clearUserData: () => initialState,
    },
});
